import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ValueStackSection() {
  return <section className="py-20 px-4 bg-gray-100 border-y border-gray-300" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <h2 className="text-4xl md:text-6xl font-black text-center mb-16 uppercase" data-id="element-222">
          QUÉ INCLUYE EL SISTEMA
        </h2>

        <div className="space-y-8 mb-16" data-id="element-223">
          {/* Item 1 */}
          <div className="bg-white border-l-8 border-yellow-400 p-8 rounded-r-2xl shadow-lg" data-id="element-224">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-225">
              <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 hover:scale-105 transition-transform" data-id="element-226">
                <img src="https://cdn.magicpatterns.com/uploads/iGsbmnLhvxdPTvcooth1VH/SISTEMA_DIARIO_DE_VENTAS.png" alt="Sistema Diario de Ventas" className="w-40 md:w-48 rounded-xl shadow-lg border-2 border-gray-200" data-id="element-227" />
              </a>
              <div data-id="element-228">
                <h3 className="text-2xl md:text-4xl font-black text-black mb-4 uppercase" data-id="element-229">
                  🔹 1. SISTEMA DIARIO DE VENTAS
                </h3>
                <p className="text-xl text-gray-700 font-bold mb-6" data-id="element-230">
                  Qué hacer todos los días para generar ingresos constantes
                </p>
                <ul className="space-y-3 text-lg text-gray-800" data-id="element-231">
                  <li className="flex items-start gap-3" data-id="element-232">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-233" />
                    <span data-id="element-234">
                      Estructura simple en 3 bloques:{' '}
                      <strong data-id="element-235">Contenido, Interacción, Ventas</strong>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-236">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-237" />
                    <span data-id="element-238">Eliminás la duda de "¿qué hago hoy?"</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-239">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-240" />
                    <span data-id="element-241">Pasás de caos a claridad total</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Item 2 */}
          <div className="bg-white border-l-8 border-yellow-400 p-8 rounded-r-2xl shadow-lg" data-id="element-242">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-243">
              <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 hover:scale-105 transition-transform" data-id="element-244">
                <img src="https://cdn.magicpatterns.com/uploads/aEtipkkxDz5p48Ki9dVWkB/100_IDEAS_DE_CONTENIDO_QUE_VENDEN.png" alt="100 Ideas de Contenido que Venden" className="w-40 md:w-48 rounded-xl shadow-lg border-2 border-gray-200" data-id="element-245" />
              </a>
              <div data-id="element-246">
                <h3 className="text-2xl md:text-4xl font-black text-black mb-4 uppercase" data-id="element-247">
                  🔹 2. 100 IDEAS DE CONTENIDO QUE VENDEN
                </h3>
                <p className="text-xl text-gray-700 font-bold mb-6" data-id="element-248">
                  Nunca más te quedás sin ideas
                </p>
                <ul className="space-y-3 text-lg text-gray-800" data-id="element-249">
                  <li className="flex items-start gap-3" data-id="element-250">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-251" />
                    <span data-id="element-252">100 ideas listas para usar</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-253">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-254" />
                    <span data-id="element-255">Contenido diseñado para atraer clientes</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-256">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-257" />
                    <span data-id="element-258">Convertís seguidores en compradores</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Item 3 */}
          <div className="bg-white border-l-8 border-yellow-400 p-8 rounded-r-2xl shadow-lg" data-id="element-259">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-260">
              <a href="https://valordigital.store/cart/46518849142973:1" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 hover:scale-105 transition-transform" data-id="element-261">
                <img src="https://cdn.magicpatterns.com/uploads/rHFm74fWMt4gzZjifk4XeT/GUIONES_DE_VENTA_QUE_CONVIERTEN.png" alt="Guiones de Venta que Convierten" className="w-40 md:w-48 rounded-xl shadow-lg border-2 border-gray-200" data-id="element-262" />
              </a>
              <div data-id="element-263">
                <h3 className="text-2xl md:text-4xl font-black text-black mb-4 uppercase" data-id="element-264">
                  🔹 3. GUIONES DE VENTA QUE CONVIERTEN
                </h3>
                <p className="text-xl text-gray-700 font-bold mb-6" data-id="element-265">
                  Sabés exactamente qué decir para cerrar
                </p>
                <ul className="space-y-3 text-lg text-gray-800" data-id="element-266">
                  <li className="flex items-start gap-3" data-id="element-267">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-268" />
                    <span data-id="element-269">Mensajes listos para copiar/adaptar</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-270">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-271" />
                    <span data-id="element-272">Vendés sin incomodar</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-273">
                    <CheckIcon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-274" />
                    <span data-id="element-275">Convertís conversaciones en ingresos</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Item 4 */}
          <div className="bg-white border-l-8 border-red-600 p-8 rounded-r-2xl shadow-lg relative overflow-hidden" data-id="element-276">
            <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-277">
              Principal
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-black mb-4 uppercase" data-id="element-278">
              🔹 4. MEGAPACK: DE 0 A VENTAS EN 30 DÍAS
            </h3>
            <p className="text-xl text-gray-700 font-bold mb-6" data-id="element-279">
              El roadmap completo paso a paso
            </p>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-280">
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-281">
                <h4 className="font-black text-xl mb-3" data-id="element-282">Tomo 1:</h4>
                <ul className="space-y-2 text-gray-800 font-medium" data-id="element-283">
                  <li data-id="element-284">✔ Claridad</li>
                  <li data-id="element-285">✔ Oferta</li>
                  <li data-id="element-286">✔ Enfoque</li>
                  <li className="mt-4 text-green-600 font-bold" data-id="element-287">
                    👉 Base sólida para vender
                  </li>
                </ul>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-288">
                <h4 className="font-black text-xl mb-3" data-id="element-289">Tomo 2:</h4>
                <ul className="space-y-2 text-gray-800 font-medium" data-id="element-290">
                  <li data-id="element-291">✔ Conversión</li>
                  <li data-id="element-292">✔ Ejecución</li>
                  <li data-id="element-293">✔ Ventas reales</li>
                  <li className="mt-4 text-green-600 font-bold" data-id="element-294">
                    👉 Pasás de interés a ingresos
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <CTAButton text="LO QUIERO TODO AHORA" data-id="element-295" />
      </div>
    </section>;
}